import { z } from 'zod';
import { pageQuerySchema } from './marketplace.js';
/**
 * Help and support. [Parent step 28]
 *
 * Two halves that answer two different questions. The help centre answers "how
 * does this work?" without anyone having to wait for a reply. A support ticket
 * answers "this is not working for me", and is deliberately separate from the
 * safety module — a billing question and a teen in trouble must never queue
 * behind each other.
 */
/* -------------------------------------------------------------------------- */
/* Help centre                                                                */
/* -------------------------------------------------------------------------- */
export const helpAudienceSchema = z.enum(['TEEN', 'PARENT', 'JOB_POSTER', 'EVERYONE']);
export const helpArticleSchema = z.object({
    slug: z.string(),
    question: z.string(),
    answer: z.string(),
    audience: helpAudienceSchema,
    /** Grouping for the page, e.g. "Getting started". */
    topic: z.string(),
});
export const helpResponseSchema = z.object({
    articles: z.array(helpArticleSchema),
    /** Where to go when the answer is not here. */
    contactEmail: z.string(),
});
/* -------------------------------------------------------------------------- */
/* Support tickets                                                            */
/* -------------------------------------------------------------------------- */
export const supportTicketStatusSchema = z.enum(['OPEN', 'ANSWERED', 'CLOSED']);
export const supportTopicSchema = z.enum([
    'ACCOUNT',
    'PAYMENTS',
    'A_JOB',
    'SOMETHING_BROKEN',
    'OTHER',
]);
export const SUPPORT_TOPIC_LABEL = {
    ACCOUNT: 'My account',
    PAYMENTS: 'Payments',
    A_JOB: 'A job',
    SOMETHING_BROKEN: 'Something is broken',
    OTHER: 'Something else',
};
export const supportTicketSchema = z.object({
    id: z.string(),
    topic: supportTopicSchema,
    subject: z.string(),
    message: z.string(),
    status: supportTicketStatusSchema,
    createdAt: z.string(),
});
export const createSupportTicketInputSchema = z.object({
    topic: supportTopicSchema,
    subject: z.string().trim().min(3, 'Give it a short title').max(150),
    message: z
        .string()
        .trim()
        .min(10, 'Tell us a little more — a sentence or two is enough')
        .max(4000),
});
export const supportTicketListQuerySchema = pageQuerySchema.extend({
    status: supportTicketStatusSchema.optional(),
});
//# sourceMappingURL=support.js.map